import { ActionBar } from '@/components/layout/ActionBar';
import { Button } from '@/components/ui/button';
import { FlexRow } from '@/components/ui/flex';
import { Text } from '@/components/ui/text';
import type { BackOfficeUserProfile } from '@ditto/shared';
import { Trash, X } from 'lucide-react';
import { useState, type FC } from 'react';
import { toast } from 'sonner';

import { BulkDeleteUsersModal } from './BulkDeleteUsersModal';

interface UsersActionBarProps {
  open: boolean;
  selectedUsers: BackOfficeUserProfile[];
  onClearSelection: () => void;
}

export const UsersActionBar: FC<UsersActionBarProps> = ({
  open,
  selectedUsers,
  onClearSelection,
}) => {
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const handleClose = () => {
    onClearSelection();
  };

  const handleDeleteClick = () => {
    setDeleteModalOpen(true);
  };

  const handleDeleteSuccess = () => {
    toast.success('Users deleted successfully');
    onClearSelection();
  };

  return (
    <ActionBar open={open}>
      <FlexRow gap="6" alignItems="center" justifyContent="between" w="full">
        <FlexRow gap="2" alignItems="center">
          <Button variant="link" size="icon" onClick={handleClose}>
            <X className="text-white" />
          </Button>
          <Text variant="body-sm" className="text-white">
            {`${selectedUsers.length} user(s) selected`}
          </Text>
        </FlexRow>
        <FlexRow gap="2">
          <Button variant="secondary" onClick={handleDeleteClick}>
            <Trash />
            Delete
          </Button>
        </FlexRow>
      </FlexRow>
      <BulkDeleteUsersModal
        users={selectedUsers}
        open={deleteModalOpen}
        onOpenChange={setDeleteModalOpen}
        onSuccess={handleDeleteSuccess}
      />
    </ActionBar>
  );
};
